import { Injectable } from '@angular/core';
import { AbstractAutoCompleteSearch, AutoCompleteSearchParams } from '@forgerock/backstage-ui-core';
import { EverythingSearchParamsOptions } from './model/everything-search-params';
import { EverythingSearchResult } from './model/everything-search-result';

@Injectable({
  providedIn: 'root'
})
export class EverythingAutocompleteSearchService extends AbstractAutoCompleteSearch<EverythingSearchResult> {
  override debounceTime = 100;
  override url = '/search-ws/api/v1/everything/_complete';

  /**
   * Sets the new params in the state, which in turn updates the params in this object.
   * The params are meant to be immutable, and each change replaces it with a new object.
   */
  withParams(params: Partial<EverythingSearchParamsOptions>): this {
    if (params) {
      this.params = new AutoCompleteSearchParams({
        ...this.params,
        ...params,
        highlight: true
      });
    }
    return this;
  }

}
